"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeformMode = void 0;
const draw_polygon_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/modes/draw_polygon"));
const constants_1 = require("@mapbox/mapbox-gl-draw/src/constants");
const double_click_zoom_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/double_click_zoom"));
exports.FreeformMode = Object.assign({}, draw_polygon_1.default);
exports.FreeformMode.onSetup = function () {
    const polygon = this.newFeature({
        type: constants_1.geojsonTypes.FEATURE,
        properties: {},
        geometry: {
            type: constants_1.geojsonTypes.POLYGON,
            coordinates: [],
        },
    });
    this.addFeature(polygon);
    this.clearSelectedFeatures();
    double_click_zoom_1.default.disable(this);
    // disable dragPan
    setTimeout(() => {
        if (!this.map || !this.map.dragPan)
            return;
        this.map.dragPan.disable();
    }, 0);
    this.updateUIClasses({ mouse: constants_1.cursors.ADD });
    this.activateUIButton(constants_1.types.POLYGON);
    this.setActionableState({
        trash: true,
    });
    return {
        polygon,
        currentVertexPosition: 0,
        dragMoving: false,
    };
};
exports.FreeformMode.onDrag = exports.FreeformMode.onTouchMove = function (state, e) {
    state.dragMoving = true;
    this.updateUIClasses({ mouse: constants_1.cursors.ADD });
    state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
    state.currentVertexPosition++;
    state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
};
exports.FreeformMode.onMouseUp = function (state) {
    if (state.dragMoving) {
        this.changeMode(constants_1.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
    }
};
exports.FreeformMode.onTouchEnd = function (state) {
    this.onMouseUp(state);
};
